import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  width: 350px;
  height: 420px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  border-top: 8px solid #00aef7;
`;

const Header = styled.div`
  padding: 12px;
  background: #00aef7;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  cursor: move;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
`;

const CloseButton = styled.button`
  color: white;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px 6px 12px;
  position: relative;  // Add this
  z-index: 9999;       // Force it on top
  pointer-events: auto; // Ensure it can receive clicks

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
`;

const ContentArea = styled.div`
  padding: 0px 0px -8px 24px;
  height: calc(100% - 20px);
`;

const DraggableContainer = ({ children, title = 'Profile Assistant', onClose }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);
  const localRef = useRef(null);

  const handleMouseDown = (e) => {
    if (
      e.target.closest('.header') &&
      !e.target.closest('button') &&
      !e.target.closest('svg')
    ) {
      setIsDragging(true);
      const rect = containerRef.current.getBoundingClientRect();
      setDragOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const newX = e.clientX - dragOffset.x;
    const newY = e.clientY - dragOffset.y;
    
    const container = containerRef.current;
    const rect = container.getBoundingClientRect();
    const maxX = window.innerWidth - rect.width;
    const maxY = window.innerHeight - rect.height;

    setPosition({
      x: Math.max(0, Math.min(newX, maxX)),
      y: Math.max(0, Math.min(newY, maxY))
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    // Center the container on mount
    if (containerRef.current) {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;

      setPosition({
        x: (windowWidth - containerWidth) / 2,
        y: (windowHeight - containerHeight) / 2
      });
    }
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, handleMouseMove]);

return (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 999,
    }}
onMouseDown={(e) => {
  if (
    containerRef.current &&
    !containerRef.current.contains(e.target)
  ) {
    // ► Start fade‑out
    containerRef.current.classList.add('fade-out');

    // ► Remove after the transition ends (0.4 s)
    setTimeout(() => {
      if (onClose) onClose();
    }, 400);
  }
}}

  >
<Container
  ref={containerRef}
  style={{
    position: 'absolute',
    left: `${position.x}px`,
    top: `${position.y}px`,
    zIndex: 1000, // Higher than the wrapper
    opacity: position.x === 0 && position.y === 0 ? 0 : 1,
    transition: 'opacity 0.4s ease-in-out'
  }}
  onMouseDown={(e) => {
    // Prevent bubbling to parent container
    e.stopPropagation();
  }}
>

      <Header className="header" onMouseDown={handleMouseDown}>
        <span>{title}</span>
      </Header>
      <ContentArea>{children}</ContentArea>
    </Container>
  </div>
);


};

export default DraggableContainer;